/**
 * RIDAA Product Media Gallery Controller (KLAY Architecture)
 * Handles vertical thumbnail rail, circular prev/next arrows, and mobile touch swipes with slide counter
 */

class RidaaProductGallery {
  constructor() {
    this.gallery = document.querySelector('[data-product-gallery]');
    if (!this.gallery) return;

    this.mainImage = this.gallery.querySelector('[data-gallery-main-image]');
    this.thumbs = Array.from(this.gallery.querySelectorAll('[data-gallery-thumb]'));
    this.prevBtn = this.gallery.querySelector('[data-gallery-prev]');
    this.nextBtn = this.gallery.querySelector('[data-gallery-next]');
    this.counterCurrent = this.gallery.querySelector('[data-current-index]');
    this.currentIndex = 0;

    this.init();
  }

  init() {
    // Determine active index
    const activeThumb = this.gallery.querySelector('[data-gallery-thumb].is-active');
    if (activeThumb) {
      this.currentIndex = this.thumbs.indexOf(activeThumb);
      if (this.counterCurrent) {
        this.counterCurrent.textContent = this.currentIndex + 1;
      }
    }

    // Thumb clicks
    this.thumbs.forEach((thumb, idx) => {
      thumb.addEventListener('click', (e) => {
        e.preventDefault();
        this.selectIndex(idx);
      });
    });

    // Arrow controls
    if (this.prevBtn && this.thumbs.length > 1) {
      this.prevBtn.addEventListener('click', (e) => {
        e.preventDefault();
        const prevIdx = (this.currentIndex - 1 + this.thumbs.length) % this.thumbs.length;
        this.selectIndex(prevIdx);
      });
    }

    if (this.nextBtn && this.thumbs.length > 1) {
      this.nextBtn.addEventListener('click', (e) => {
        e.preventDefault();
        const nextIdx = (this.currentIndex + 1) % this.thumbs.length;
        this.selectIndex(nextIdx);
      });
    }

    // Touch swipe support for mobile
    let touchStartX = 0;
    let touchEndX = 0;
    const mainWrap = this.gallery.querySelector('.vela-product-gallery__main-wrap') || this.gallery.querySelector('.klay-gallery__main-wrap') || this.gallery;

    mainWrap.addEventListener('touchstart', (e) => {
      touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });

    mainWrap.addEventListener('touchend', (e) => {
      touchEndX = e.changedTouches[0].screenX;
      if (touchStartX - touchEndX > 45 && this.thumbs.length > 1) {
        // Swiped left -> next
        const nextIdx = (this.currentIndex + 1) % this.thumbs.length;
        this.selectIndex(nextIdx);
      } else if (touchEndX - touchStartX > 45 && this.thumbs.length > 1) {
        // Swiped right -> prev
        const prevIdx = (this.currentIndex - 1 + this.thumbs.length) % this.thumbs.length;
        this.selectIndex(prevIdx);
      }
    }, { passive: true });
  }

  selectIndex(idx) {
    if (idx < 0 || idx >= this.thumbs.length) return;
    this.currentIndex = idx;
    const thumb = this.thumbs[idx];
    const fullSrc = thumb.dataset.fullSrc;
    const fullSrcset = thumb.dataset.fullSrcset;
    const alt = thumb.dataset.alt || '';

    if (this.mainImage && fullSrc) {
      this.mainImage.src = fullSrc;
      if (fullSrcset) this.mainImage.srcset = fullSrcset;
      this.mainImage.alt = alt;
    }

    this.thumbs.forEach((t) => {
      t.classList.remove('is-active');
      t.setAttribute('aria-selected', 'false');
    });
    thumb.classList.add('is-active');
    thumb.setAttribute('aria-selected', 'true');

    if (this.counterCurrent) {
      this.counterCurrent.textContent = idx + 1;
    }

    // Scroll active thumbnail inside vertical rail smoothly
    if (typeof thumb.scrollIntoView === 'function') {
      thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  window.Ridaa = window.Ridaa || {};
  window.Ridaa.gallery = new RidaaProductGallery();
});
